import GenericTableRequest from "@/models/api/GenericTableRequest";
import {
  AutoInvoiceServiceType,
  AutoInvoiceServiceTypeResponse,
  AutoInvoiceSetting,
  EditAutoInvoiceSetting,
} from "@/models/api/administration/contractors/AutoInvoiceSetting";
import CancellableHelper from "@/requests/CancellableHelper";

//#region routes
export const URL_POST_ADD_CONTRACTOR_AUTO_INVOICE_SETTING = "/ContractorAdministration/${ContractorId}/AutoInvoice/Add";
export const URL_GET_CONTRACTOR_AUTO_INVOICE_SETTINGS = "/ContractorAdministration/${ContractorId}/AutoInvoice";

export const URL_POST_REMOVE_CONTRACTOR_AUTO_INVOICE = "/AutoInvoiceConfiguration/${AutoInvoiceConfigurationId}/Remove";
export const URL_POST_EDIT_AUTO_INVOICE_CONFIGURATION = "/AutoInvoiceConfiguration/${AutoInvoiceConfigurationId}/Edit";
export const URL_POST_EDIT_AUTO_INVOICE_CONFIGURATION_NAME =
  "/AutoInvoiceConfiguration/${AutoInvoiceConfigurationId}/Edit/Name";
export const URL_GET_AUTO_INVOICE_CONFIGURATION_SERVICE_TYPES =
  "/AutoInvoiceConfiguration/${AutoInvoiceConfigurationId}/ServiceTypes";
export const URL_GET_AUTO_INVOICE_CONFIGURATION_FILTERED_SERVICE_TYPES =
  "/AutoInvoiceConfiguration/${AutoInvoiceConfigurationId}/FilteredServiceTypes";
export const URL_GET_AUTO_INVOICE_CONFIGURATION_ALL_SERVICE_TYPES =
  "/AutoInvoiceConfiguration/${AutoInvoiceConfigurationId}/AllServiceTypes";
export const URL_POST_EDIT_AUTO_INVOICE_CONFIGURATION_SERVICE_TYPES =
  "/AutoInvoiceConfiguration/${AutoInvoiceConfigurationId}/ServiceTypes/Edit";
//#endregion

const _addContractorAutoInvoiceSetting = new CancellableHelper<number>(
  URL_POST_ADD_CONTRACTOR_AUTO_INVOICE_SETTING,
  Number
);
export const addContractorAutoInvoiceSetting = async (contractorId: string, settingName: string): Promise<number> => {
  return _addContractorAutoInvoiceSetting.post({ ContractorId: contractorId }, settingName);
};

const _getContractorAutoInvoiceSettings = new CancellableHelper<Array<AutoInvoiceSetting>>(
  URL_GET_CONTRACTOR_AUTO_INVOICE_SETTINGS,
  AutoInvoiceSetting
);
export const getContractorAutoInvoiceSettings = async (contractorId: string): Promise<Array<AutoInvoiceSetting>> => {
  return _getContractorAutoInvoiceSettings.get({ ContractorId: contractorId });
};

const _removeAutoInvoiceConfiguration = new CancellableHelper<void>(
  URL_POST_REMOVE_CONTRACTOR_AUTO_INVOICE,
  null,
  true
);
export const removeAutoInvoiceConfiguration = async (autoInvoiceConfigurationId: number): Promise<void> => {
  return _removeAutoInvoiceConfiguration.post({
    AutoInvoiceConfigurationId: autoInvoiceConfigurationId,
  });
};

const _editAutoInvoiceConfigurationName = new CancellableHelper<void>(
  URL_POST_EDIT_AUTO_INVOICE_CONFIGURATION_NAME,
  null,
  true
);
export const editAutoInvoiceConfigurationName = async (
  autoInvoiceConfigurationId: number,
  name: string
): Promise<void> => {
  return _editAutoInvoiceConfigurationName.post(
    {
      AutoInvoiceConfigurationId: autoInvoiceConfigurationId,
    },
    name
  );
};

const _getServiceTypesAutoInvoiceConfigurations = new CancellableHelper<Array<AutoInvoiceServiceType>>(
  URL_GET_AUTO_INVOICE_CONFIGURATION_SERVICE_TYPES,
  AutoInvoiceServiceType
);
export const getServiceTypesAutoInvoiceConfigurations = async (
  autoInvoiceConfigurationId: number
): Promise<Array<AutoInvoiceServiceType>> => {
  return _getServiceTypesAutoInvoiceConfigurations.get({
    AutoInvoiceConfigurationId: autoInvoiceConfigurationId,
  });
};

const _getFilteredServiceTypesAutoInvoiceConfigurations = new CancellableHelper<Array<AutoInvoiceServiceType>>(
  URL_GET_AUTO_INVOICE_CONFIGURATION_FILTERED_SERVICE_TYPES,
  AutoInvoiceServiceType
);
_getFilteredServiceTypesAutoInvoiceConfigurations.jsonSerializer = true;
export const getFilteredServiceTypesAutoInvoiceConfigurations = async (
  genericTableRequest: GenericTableRequest,
  autoInvoiceConfigurationId: number
): Promise<Array<AutoInvoiceServiceType>> => {
  return _getFilteredServiceTypesAutoInvoiceConfigurations.get({
    ...genericTableRequest,
    AutoInvoiceConfigurationId: autoInvoiceConfigurationId,
  });
};

const _getAllServiceTypesAutoInvoiceConfigurations = new CancellableHelper<AutoInvoiceServiceTypeResponse>(
  URL_GET_AUTO_INVOICE_CONFIGURATION_ALL_SERVICE_TYPES,
  AutoInvoiceServiceTypeResponse
);
_getAllServiceTypesAutoInvoiceConfigurations.jsonSerializer = true;
export const getAllServiceTypesAutoInvoiceConfigurations = async (
  genericTableRequest: GenericTableRequest,
  autoInvoiceConfigurationId: number
): Promise<AutoInvoiceServiceTypeResponse> => {
  return _getAllServiceTypesAutoInvoiceConfigurations.get({
    ...genericTableRequest,
    AutoInvoiceConfigurationId: autoInvoiceConfigurationId,
  });
};

const _editAutoInvoiceConfigurationServiceTypes = new CancellableHelper<void>(
  URL_POST_EDIT_AUTO_INVOICE_CONFIGURATION_SERVICE_TYPES,
  null,
  true
);
export const editAutoInvoiceConfigurationServiceTypes = async (
  autoInvoiceConfigurationId: number,
  serviceTypeIds: Array<number>
): Promise<void> => {
  return _editAutoInvoiceConfigurationServiceTypes.post(
    { AutoInvoiceConfigurationId: autoInvoiceConfigurationId },
    serviceTypeIds
  );
};

const _editAutoInvoiceSetting = new CancellableHelper<void>(URL_POST_EDIT_AUTO_INVOICE_CONFIGURATION, null, true);
export const editAutoInvoiceSetting = async (
  autoInvoiceConfigurationId: number,
  autoInvoiceSetting: EditAutoInvoiceSetting
): Promise<void> => {
  return _editAutoInvoiceSetting.post({ AutoInvoiceConfigurationId: autoInvoiceConfigurationId }, autoInvoiceSetting);
};
